import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { FaEye } from "react-icons/fa";
import { useLeaveListByEmployee } from "../hooks/useEmployee";
import { showToast } from "../../../utils/toastUtils";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";

interface LeaveListProps {
  // Define any props if needed
  Employee: number;
}

const LeaveList: React.FC<LeaveListProps> = ({Employee}) => {
  // console.log('wemplyeeki id',Employee)
  const navigate = useNavigate();
const [selectedMonth,setSelectedMonth]=useState('')
const [filtersState,setFiltersState]=useState({
  limit:10,
  page:1
})
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
const currentMonth = new Date().toLocaleString("default", { month: "short" }); // e.g. "Nov"

    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
            const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
            const { startPolling, stopPolling } = useExcelPolling();

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 5 }, (_, i) => {
  const year = currentYear - i;
  return { id: year.toString(), label: year.toString() };
});


  const formatDateTime = (dateTimeStr: string) => {
    const date = new Date(dateTimeStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    });

    return `${formattedDate} ${formattedTime}`;
  };

  const LeaveListColumns = (handleLeaveView: (row: any) => void) => [
     {
      name: "Emp Code",
      selector: (row: { EmployeeCode: string }) => row.EmployeeCode,
      sortable: true,
      minWidth:'130px'
    },
    {
      name: "Type",
      selector: (row: { LeaveType: string }) => row.LeaveType,
      sortable: true,
    },
    {
      name: "Start date",
      selector: (row: { LeaveFrom: string }) => row.LeaveFrom,
      sortable: true,
      minWidth:'150px'
    },
    {
      name: "End date",
      selector: (row: { LeaveTo: string }) => row.LeaveTo,
      sortable: true,
      minWidth:'150px'

    },
    {
      name: "Status",
      selector: (row: { LeaveStatus: string }) => row.LeaveStatus,
      sortable: true,
      
    },
    {
      name: "Reason",
      selector: (row: { LeaveReason: string }) => row.LeaveReason,
      sortable: true,
      wrap:true,
      minWidth:'150px'
    },
 {
  name: "Requested on",
  selector: (row: any) =>
    row?.RequestedOn?.date ? formatDateTime(row.RequestedOn.date) : "-",
  sortable: true,
  width: "150px",
  wrap: true,
}
,
    {
      name: "Updated on",
      selector: (row: any) =>row?.UpdatedOn?.date ? formatDateTime(row.UpdatedOn.date) : "-",
      sortable: true,
      width:'150px',
      wrap:true
    },
    // {
    //   name: "Actions",
    //   cell: (row: any) => (
    //     <button
    //       onClick={() => handleLeaveView(row)}
    //       className="btn btn-primary"
    //       style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
    //     >
    //       <FaEye style={{ fill: "#fff" }} /> View
    //     </button>
    //   ),
    // },
  ];

  const {data:leaveList,isLoading:isLoading}=useLeaveListByEmployee({
    enabled:!!Employee,
    params:{
      employee_id:Employee,
      limit: filtersState.limit,
      page: filtersState.page,
      year:selectedYear
    }

  })



 

    const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleLeaveView = () => {
    navigate("/employeeDetails");
  };

  const LeaveFilterData = [
        { id: "Jan25", label: "Jan25" },
        { id: "Feb25", label: "Feb25" },
        { id: "Mar25", label: "Mar25" },
        { id: "Apr25", label: "Apr25" },
      ]

      const handleMonthFilterChange = (value: string) => {
        setSelectedMonth(value);
      };

         const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
 const employee_id=Employee;
      const limit= filtersState.limit
     const page= filtersState.page
     const year=selectedYear

    const params = new URLSearchParams();

    // Append only if the value exists

    // if (sortColumn) params.append("sortColumn", sortColumn);
    if (employee_id) params.append("employee_id", employee_id.toString());
    if (limit) params.append("limit", limit.toString());
    if (page) params.append("page", page.toString());
    if (year) params.append("year", year);
    
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_LEAVE_LIST_BY_EMPLOYEE_EXCEL}?${queryString}`
        );
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => {showToast.error(msg || "");setLoadingExcel(false)},
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
        setLoadingExcel(false)
      }
    };

 
  return (
    <div>
      <BasicDataTable
      showSpinner={isLoading}
        Title="Leave"
        paginationTotalRows={leaveList?.data?.pagination?.total_records}
        columns={LeaveListColumns(handleLeaveView)}
        data={leaveList?.data?.data}
         onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
       search={false}
        topLeftAlignContent={<>
         <button
         onClick={downloadExcelGet}
              className="btn btn-primary"
              style={{
                borderRadius: "20px",
                padding: "3px 10px",
                width: "fit-content",
              }}
            >
              Excel
            </button></>}
        tableHeaderButtonAfterSearch={true}
        filterOptionsAfterSearch={true}
        headerContent={
          <RoundedDropdown
          defaultLabel={selectedYear}
    options={years}
    onSelect={(value:any) => setSelectedYear(value.id)}
    width="fit-content"
    isShowHeading={false}
    headingColor="#2e8dd3"
    height="30px"

  />
        }

      />
    </div>
  );
};

export default LeaveList;
